<template>
  <div class="field">
    <label class="control-label"></label>
    <div class="controls">
      <div v-if="errorText" class="error">{{ errorText }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['errors', 'field', 'exclude'],

  computed: {
    errorText() {
      let errors = [];
      if (this.errors && Object.keys(this.errors).length) {
        if (this.field) {
          if (this.errors[this.field]) {
            errors = this.errors[this.field] || [];
          }
        } else {
          Object.values(this.errors).forEach((errorArray) => {
            errors = [...errors, ...errorArray];
          });
        }
      }

      if (errors.length >= 1) {
        return errors[0];
      }
      return null;
    },
  },
};
</script>
